if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus'),
						qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
						qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;

			if ( parseInt(qty.value) - 1 < qtyMin ) {
				qtyMinus.classList.add('disabled');
			}
			if ( parseInt(qty.value) + 1 > qtyMax ) {
				qtyPlus.classList.add('disabled');
			}

			qtyMinus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyMinus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					if ( currentQty - 1 >= qtyMin ) {
						qty.value = currentQty - 1;
						qtyPlus.classList.remove('disabled');
					} 
					if ( currentQty - 1 <= qtyMin ) {
						qtyMinus.classList.add('disabled');
					}
				}
			});

			qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyPlus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					if ( currentQty + 1 <= qtyMax ) {
						qty.value = currentQty + 1;
						qtyMinus.classList.remove('disabled');
					} 
					if ( currentQty + 1 >= qtyMax ) {
						qtyPlus.classList.add('disabled');
					}
				}
			});

		}
		
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}
if ( typeof SpecificProductQuantity !== 'function' ) {

	class SpecificProductQuantity extends HTMLElement {

		constructor(){

			super();
          
			const qty = document.querySelector('.qty-selector'),
						qtyChange = this.querySelectorAll('.qty-change'),
						qtyChangeSelected = this.querySelector('.qty-change.disabled'),
						qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
						qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999,
						priceSpan = document.querySelector('.product-price--original'),
                        price = this.querySelector('.specific-saved-product-price'),
                        discountType = this.querySelector('.specific-saved-discount-type');

            if(qtyChange.length>0){
              const multiple = qtyChangeSelected.getAttribute('data-val'),
                    discountVal = this.querySelector('.specific-saved-discount-'+multiple);
              
                var priceCalc = price.innerHTML;

                if(discountType.innerHTML === '%'){
                  priceCalc = priceCalc*(1-(discountVal.innerHTML/100))
                }else if(discountType.innerHTML === '$'){
                  priceCalc = priceCalc-discountVal.innerHTML
                }

                priceCalc = Math.ceil(priceCalc)*multiple;
              
                priceSpan.innerHTML = '$'+(priceCalc/100).toFixed(2);
                qty.value = multiple;
            }

            for (let i = 0; i < qtyChange.length; i++) {
              qtyChange[i].addEventListener('click', (e)=>{
                  e.preventDefault();
                  if ( ! qtyChange[i].classList.contains('disabled') ) {
                      document.querySelectorAll('.qty-change').forEach(elem => {elem.classList.remove('disabled');});
                      const currentQty = parseInt(qtyChange[i].getAttribute('data-val')),
                        discountVal = this.querySelector('.specific-saved-discount-'+currentQty);
                        qty.value = currentQty;
              
                        var priceCalc = price.innerHTML;
        
                        if(discountType.innerHTML === '%'){
                          priceCalc = priceCalc*(1-(discountVal.innerHTML/100))
                        }else if(discountType.innerHTML === '$'){
                          priceCalc = priceCalc-discountVal.innerHTML
                        }
                    
                        priceCalc = Math.ceil(priceCalc)*currentQty;
                      
                        priceSpan.innerHTML = '$'+(priceCalc/100).toFixed(2);
                    
                      qtyChange[i].classList.add('disabled');
                  }
              });
            }
		}
		
	}


  if ( typeof customElements.get('specific-product-quantity') == 'undefined' ) {
    customElements.define('specific-product-quantity', SpecificProductQuantity);
	}

}